import { collection, limit, onSnapshot, query, updateDoc, doc } from 'firebase/firestore';
import { firestore } from '../views/firebaseConfig';
import { COLLECTIONS } from '../contracts/p4r';

export function listenMyBookings(uid,onData,onError){
  const q=query(collection(firestore,COLLECTIONS.BUSINESS_EVENTS),limit(250));
  return onSnapshot(q,(snapshot)=>{
    const bookings=snapshot.docs.map((item)=>({id:item.id,...item.data()})).filter((item)=>item.booking?.[uid]==='booked'&&String(item.status||'').toLowerCase()==='active').sort((a,b)=>(a.dateTime?.seconds||0)-(b.dateTime?.seconds||0));
    onData(bookings);
  },onError);
}
export async function cancelBooking(eventId,uid){await updateDoc(doc(firestore,COLLECTIONS.BUSINESS_EVENTS,eventId),{[`booking.${uid}`]:'cancelledbyuser'});}
